function updateSlickDots($slider, visibleCount = 3, nextSlide = 1) {
	const dots = $slider.find('.slick-dots li');

	var start = Math.floor(nextSlide / visibleCount) * visibleCount;
	var end = start + visibleCount;

	dots.css('display', 'none');
	dots.slice(start, end).css('display', 'block');
}

function initProductCardSlider(
	$mediaSlider = $('.card__media-slider'),
	$isInitFirstLoad = true,
) {
	$mediaSlider.each(function () {
		const $slider = $(this);
		const $wrap = $slider.closest('.card__media');

		if ($isInitFirstLoad && $slider.hasClass('no-init-first-load')) return;

		$slider.on(
			'init reInit beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				updateSlickDots($(this), 3, nextSlide);
			},
		);

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			prevArrow: $wrap.find('.card__media-arrow--prev'),
			nextArrow: $wrap.find('.card__media-arrow--next'),
		});
	});
}
